<template>
  <v-container fluid class="bg-image">
    <v-row class="mx-3">
      <v-btn text color="white" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" @click="changeLang('fr')">FR</v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="white" to="/login">{{ $t("login") }}</v-btn>
      <p class="my-0 mt-1 white--text">|</p>
      <v-btn text color="white" to="/register">{{ $t("register") }}</v-btn>
    </v-row>
    <v-layout justify-center>
      <v-flex xs12 sm12 md10 class="text-center">
        <v-img
          class="mb-3"
          :src="imageLogoUrlWhite"
          :max-height="imageHeight"
          contain
          aspect-ratio="1.7"
        ></v-img>
        <!-- SHITE HERE -->
        <v-row justify="center" class="my-9">
          <v-col cols="10" md="8" class="ma-0 pa-0">
            <v-row class="pos-relative">
              <div class="white--text position-welcome" :class="textSize">
                {{ $t("welcome") }}
              </div>
              <v-card elevation="0" class="card welcome-card">
                <v-card-text class="px-10 py-7">
                  <p class="white--text">{{ $t("welcome_message") }}</p>
                </v-card-text>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-row justify="center">
              <img
                @click="$router.push('/choose-regions')"
                src="@/assets/images/Browse2.png"
                class="icon-image"
                alt="browse auctions"
              />
            </v-row>
            <v-btn :to="`/choose-regions`" color="primary" class="my-6">{{
              $t("browse_travel_packages")
            }}</v-btn>
          </v-col>
          <v-col cols="12" sm="4">
            <v-row justify="center">
              <img src="@/assets/images/Login2.png" @click="$router.push('/login')" class="icon-image" alt="" />
            </v-row>
            <v-btn :to="'/login'" color="primary" width="175px" class="my-6">{{
              $t("login")
            }}</v-btn>
          </v-col>
          <v-col cols="12" sm="4">
            <v-row justify="center">
              <img @click="$router.push('/FAQ')"  src="@/assets/images/Faq2.png" class="icon-image" alt="" />
            </v-row>
            <v-btn :to="'/FAQ'" color="primary" width="175px" class="my-6">{{
              $t("FAQ")
            }}</v-btn>
          </v-col>
        </v-row>
        <v-row justify-lg="center">
          <v-col cols="12" md="12" class="ma-0 pa-0">
            <p class="caption font-weight-regular ma-0 pa-0 white--text">
              {{ $t("dont_have_account") }}
              <a
                @click.stop.prevent="$router.push('/register')"
                class="white--text a-underline"
                >{{ $t("sign_up") }}</a
              >
            </p>
          </v-col>
        </v-row>
        <app-footer class="mt-11" />
      </v-flex>
    </v-layout>

    <!-- <v-bottom-sheet no-click-animation v-model="sheet" hide-overlay persistent>
      <v-sheet class="text-center" height="75px" color="#071A2A">
        <v-row justify="center">
          <v-col cols="11" md="10">
            <p
              class="ma-0 white--text caption"
            >This website uses cookies for personalization and to remember your preferences. Learn more about privacy policy or change your cookie preferences. By continuing to use our service, you agree to our use of cookies.</p>
          </v-col>
          <v-col cols="1">
            <v-icon @click="sheet=false" small color="white" class="mb-11 pb-2">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>-->
  </v-container>
</template>

<script>
import { CONSUMERS_API } from '@/clients/consumers.api'
import { Validations } from '@/utils/validations'
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {
    AppFooter: () => import('@/components/Footer.vue')
  },
  mounted () {
    console.log(this.$t('email_confirmation'))
  },
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      showPassword: false,
      sheet: true
    }
  },
  methods: {
    ...mapMutations({
      setAgeVerificationStatus: 'Auth/SET_AGE_VERIFICATION_STATUS'
    }),
    ...Validations,
    ...mapActions({
      va_loginWithEmail: 'Auth/loginWithEmail'
    }),
    async login () {
      if (!this.$refs['login-form'].validate()) {
        await this.$nextTick()
        const el = document.querySelector('.v-messages__message:first-of-type')
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      try {
        await this.va_loginWithEmail(this.user)
      } catch (e) {
        console.log(e.error)
        return this.$snackbar({ text: Array.isArray(e.error.payload) ? e.error.payload.join(' | ') : e.error.msg, color: 'error', timeout: 7000 })
      }
      this.setAgeVerificationStatus(true)
      this.$router.push('/choose-regions')
    }
  },
  computed: {
    imageHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '120px'
        case 'sm': return '150px'
        case 'md': return '225px'
        case 'lg': return '250px'
        case 'xl': return '250px'
        default: return '150px'
      }
    },
    textSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'text-h5'
        case 'sm': return 'text-h5'
        case 'md': return 'text-h4'
        case 'lg': return 'text-h4'
        case 'xl': return 'text-h4'
        default: return 'text-h4'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.a-underline {
  text-decoration: underline;
}
.bg-image {
  background: linear-gradient(
      0deg,
      rgba(2, 16, 48, 0.25),
      rgba(2, 16, 48, 0.25)
    ),
    url("../assets/images/Stock/background-image.jpg");
  /* Background image is centered vertically and horizontally at all times */
  background-position: center center;

  /* Background image doesn't tile */
  background-repeat: no-repeat;

  /* Background image is fixed in the viewport so that it doesn't move when
     the content's height is greater than the image's height */
  background-attachment: fixed;

  /* This is what makes the background image rescale based
     on the container's size */
  background-size: cover;

  /* Set a background color that will be displayed
     while the background image is loading */
}

.forget-password-card {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
.card {
  background: rgba(255, 255, 255, 0) !important;
}

.welcome-card {
  border-left: 2px solid white !important;
  border-right: 2px solid white !important;
  border-bottom: 2px solid white !important;
  position: relative !important;
  background: rgba(255, 255, 255, 0) !important;
}

.welcome-card :after {
  content: "";
  border: 1px solid white;
  display: block;
  position: absolute;
  width: 35%;
  top: 0px;
  left: 0px;
}

.welcome-card :before {
  content: "";
  border: 1px solid white;
  display: block;
  position: absolute;
  width: 35%;
  top: 0px;
  right: 0;
}

@media only screen and (max-width: 500px) {
  .welcome-card :after {
    content: "";
    border: 1px solid white;
    display: block;
    position: absolute;
    width: 30%;
    top: 0px;
    left: 0px;
  }

  .welcome-card :before {
    content: "";
    border: 1px solid white;
    display: block;
    position: absolute;
    width: 30%;
    top: 0px;
    right: 0;
  }
}

.position-welcome {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: -15px;
  text-align: center;
}

.pos-relative {
  position: relative;
}

.icon-image {
  max-height: 135px;
  min-height: 135px;
  width: auto;
}
.icon-image:hover {
  cursor: pointer;
}
</style>
